import React from 'react';
import { images } from '../shared/assets';
import './ReEnergizeHero.css';

const ReEnergizeHero: React.FC = () => {
  return (
    <section className="re-energize-hero" data-scroll-section>
      {/* Video Background */}
      <div className="re-energize-hero__bg-container">
        <div className="re-energize-hero__hero-media">
          <video
            className="re-energize-hero__hero-video"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/assets/re-energize-hero-video.mp4" type="video/mp4" />
          </video>
          <div className="re-energize-hero__gradient-overlay" />
        </div>
        
        {/* Content */}
        <div className="re-energize-hero__content">
          <h1 className="re-energize-hero__title">Re-energize and Thrive</h1>
        </div>
        
        {/* Volume Button */}
        <button className="volume-button" aria-label="Toggle volume">
          <img src={images.volumeIcon} alt="Volume" />
        </button>
      </div>
    </section>
  );
};

export default ReEnergizeHero;